// import {orderBy} from "@progress/kendo-data-query";
// //import { filterBy } from '@progress/kendo-data-query';
// import moment from "moment";
// import {saveExcel} from "@progress/kendo-vue-excel-export";
// import api from "../../services/api";

// export default {
// 	components: {},
// 	data: function() {
// 		return {
// 			date: "12/07/2019",
// 			loading: false,
// 			items: [],
// 			skip: 0,
// 			take: 10,
// 			total: 0,
// 			pageSize: 20,
// 			pageIndex: 0,
// 			pageable: {
// 				buttonCount: 5,
// 				info: true,
// 				type: "numeric",
// 				pageSizes: false,
// 				previousNext: true
// 			},
// 			sort: [],
// 			filter: {
// 				logic: "and",
// 				filters: [
// 					{
// 						field: "UnitPrice",
// 						operator: "neq",
// 						value: 18
// 					},
// 					{
// 						field: "FirstOrderedOn",
// 						operator: "gte",
// 						value: new Date("1996-10-10")
// 					}
// 				]
// 			},
// 			itemsForFilter: [],
// 			filteredItems: [6749, 6751]
// 		};
// 	},
// 	created() {
// 		//this.getData(1);
// 		this.getAllVehicles();
// 	},
// 	methods: {
// 		getAllVehicles: function() {
// 			var self = this;
// 			api.getVehiclesLookup({page: 0, pageSize: 1000000}).then(res => {
// 				self.itemsForFilter = res.items.map(function(vehicle) {
// 					return {
// 						id: vehicle.id,
// 						name: vehicle.name,
// 						number_plate: vehicle.number_plate,
// 						name_numberplate: `${vehicle.number_plate} ${vehicle.name}`
// 					};
// 				});
// 			});
// 		},
// 		sortChangeHandler: function(e) {
// 			this.sort = e.sort;

// 			this.getData();
// 		},
// 		filterChange: function(ev) {
// 			this.filter = ev.filter;
// 		},
// 		pageChangeHandler: function(event) {
// 			this.skip = event.page.skip;
// 			this.take = event.page.take;

// 			if (this.skip === 0) {
// 				this.pageIndex = 0;
// 			}
// 			this.pageIndex = this.skip / this.take;

// 			this.getData();
// 		},
// 		exportExcel() {
// 			saveExcel({
// 				data: this.items,
// 				fileName: "test",
// 				columns: [
// 					{
// 						field: "id"
// 					},
// 					{
// 						field: "plate",
// 						title: "plate"
// 					},
// 					{
// 						field: "driver",
// 						title: "driver"
// 					},
// 					{
// 						field: "date",
// 						title: "date"
// 					},
// 					{
// 						field: "location",
// 						title: "location"
// 					},
// 					{
// 						field: "eventType",
// 						title: "eventType"
// 					}
// 				]
// 			});
// 		},
// 		getData: function() {
// 			var self = this;
// 			this.loading = true;

// 			api.getAlarmsData(this.pageIndex, this.sortColumn, this.sortDirection).then(res => {
// 				self.loading = false;

// 				self.items = res.items.map(function(item) {
// 					return {
// 						id: item.id,
// 						plate: item.plate,
// 						driver: item.driver,
// 						date: moment(item.date).format("DD/MM/YYYY HH:mm:ss"),
// 						location: item.location.address + "|" + item.location.city,
// 						eventTyper: item.eventType
// 					};
// 				});

// 				self.total = res.totalCount;
// 			});
// 		},
// 		changeItemSelection(item) {
// 			if (item.selected) {
// 				var i = this.filteredItems.findIndex((x) => {
// 					return x == item.id;
// 				});

// 				if (i >= 0) {
// 					this.filteredItems.splice(i, 1);
// 				}
// 			}
// 			else {
// 				this.filteredItems.push(item.id);
// 			}
// 		}
// 	},

// 	computed: {
// 		filterItems: function(){
// 			var itemsToShow = [];
// 			for (var i = 0; i < this.itemsForFilter.length; i++) {
// 				var item = this.itemsForFilter[i];
// 				var isSelected = this.filteredItems.findIndex((x) => {
// 					return x == item.id;
// 				}) >= 0;

// 				itemsToShow.push({
// 					id: item.id,
// 					name: item.name,
// 					selected: isSelected
// 				});
// 			}

// 			return itemsToShow;
// 		},
// 		result: {
// 			get: function() {
// 				var self = this;

// 				var orderedResult = orderBy(self.items, this.sort);
// 				//var filteredResult = filterBy(orderedResult, this.filter);
// 				return orderedResult;
// 			}
// 		},
// 		columns: function() {
// 			return [
// 				{
// 					field: "id",
// 					filterable: false,
// 					sortable: false,
// 					title: "id",
// 					width: "33px"
// 				},
// 				{
// 					field: "plate",
// 					filterable: false,
// 					sortable: false,
// 					title: "targa",
// 					width: "120px"
// 				},
// 				{
// 					field: "driver",
// 					filterable: false,
// 					sortable: false,
// 					title: "conducente"
// 				},
// 				{
// 					field: "date",
// 					filter: "date",
// 					filterable: false,
// 					sortable: false,
// 					title: "data",
// 					width: "120px"
// 				},
// 				{
// 					field: "date",
// 					filter: "date",
// 					filterable: false,
// 					sortable: false,
// 					title: "ora",
// 					width: "120px"
// 				},
// 				{
// 					field: "location",
// 					filter: "location",
// 					filterable: false,
// 					sortable: false,
// 					title: "luogo",
// 					width: "240px"
// 				},
// 				{
// 					field: "eventTyper",
// 					filterable: false,
// 					sortable: false,
// 					title: "tipo evento"
// 				}
// 			];
// 		}
// 	}
// };
import api from "../../services/api";
import gridbase from "../../components/gridComponentBase.js";
import helpers from "../../shared/fleetbox-helpers";

import { Marker, Polyline } from "../../domain/poi";

export default {
	extends: gridbase,
	components: {},
	data: function() {
		return {
			mapInitialLocation: {
				lat: 0,
				lng: 0
			},
			markers: [],
			paths: []
		};
	},
	created() {
		var self = this;

		self.mapInitialLocation.lat = 43.1107;
		self.mapInitialLocation.lng = 12.3908;

		this.getData();
	},
	methods: {
		getData: function() {
			var self = this;
			this.loading = true;

			api.getPoisData(this.query).then(res => {
				self.loading = false;
				self.items = res.items;

				self.total = res.totalCount;

				self.$nextTick(function() {
					self.displayAllMarkers();
				});
			});
		},
		displayAllMarkers: function() {
			var self = this;

			self.items.forEach(function(item, index) {
				var m = new Marker();
				m.position = item.location.points[0];
				m.title = item.name;

				self.markers.push(m);
			});
		},
		addDemoMarker: function() {
			var m = new Marker();
			m.position.lat = 43.1107;
			m.position.lng = 12.3908;
			m.title = "Esempio di marker";

			this.markers.push(m);
		},
		addDemoPath: function() {
			//test percorso da Piazza Matteotti a Ponte San Giovanni
			var points = helpers.decodeGooglePolyline(
				"wdcfGizrjAUCYKc@Wg@[SSKKSa@GW?SLe@lAeCl@y@f@EKfAOjAALDHF@N?\\E\\GH?LEHJHBFDLFBG@][WQ_@@KDUHYHFZPb@VPFhAJ`@Ip@W`A]b@E~@JbADZCTS\\o@T{@VyAv@iCLs@@u@F[JQJKZITFVLlAjAd@P^HR?t@OTMNGxAOb@I`@S\\g@FOP{@Ve@j@{GNyB?y@IcAEm@?o@JgBT_Al@eB^_AfAkDtAuDd@gBd@yCJeABaBw@eCOw@H_BFe@X{@dBwCnCqF`@cA|@kAnCqDlAiBrDwGdCqEhDwFHYBYGqCGqCA_BMsEIeCWaWDa@hAiC~DsIxG{NtBkEXu@lA}Dv@cCTeAVoANcAHiARiEFuAH]v@]|Ae@r@[bAk@Ve@FWD]?_@O{AAq@Fi@Pk@Xa@`@Qn@OLAJBJFLfATdB\\zBn@UJMDI?YKQq@w@]i@M]WmBYmCC]U{@?A?A@CAEAA@Wa@cFc@cFEa@AOh@q@jC_D`@g@fCcDHDJCDK?OEMEA"
			);

			var coordinates = points.map(function(item) {
				return {
					lat: item[0],
					lng: item[1]
				};
			});

			var mStart = new Marker();
			mStart.position.lat = coordinates[0].lat;
			mStart.position.lng = coordinates[0].lng;
			mStart.title = "Partenza";
			this.markers.push(mStart);

			var mEnd = new Marker();
			mEnd.position.lat = coordinates[coordinates.length - 1].lat;
			mEnd.position.lng = coordinates[coordinates.length - 1].lng;
			mEnd.title = "Arrivo";
			this.markers.push(mEnd);

			var line = new Polyline();
			line.path = coordinates;
			line.strokeColor = "blue";
			line.strokeOpacity = 1.0;
			line.linestrokeWeight = 2;

			this.paths.push(line);
		},
		addDemoPathManual: function() {
			//test percorso da Piazza Matteotti a Ponte San Giovanni
			var points = helpers.decodeGooglePolyline(
				"wdcfGizrjAUCYKc@Wg@[SSKKSa@GW?SLe@lAeCl@y@f@EKfAOjAALDHF@N?\\E\\GH?LEHJHBFDLFBG@][WQ_@@KDUHYHFZPb@VPFhAJ`@Ip@W`A]b@E~@JbADZCTS\\o@T{@VyAv@iCLs@@u@F[JQJKZITFVLlAjAd@P^HR?t@OTMNGxAOb@I`@S\\g@FOP{@Ve@j@{GNyB?y@IcAEm@?o@JgBT_Al@eB^_AfAkDtAuDd@gBd@yCJeABaBw@eCOw@H_BFe@X{@dBwCnCqF`@cA|@kAnCqDlAiBrDwGdCqEhDwFHYBYGqCGqCA_BMsEIeCWaWDa@hAiC~DsIxG{NtBkEXu@lA}Dv@cCTeAVoANcAHiARiEFuAH]v@]|Ae@r@[bAk@Ve@FWD]?_@O{AAq@Fi@Pk@Xa@`@Qn@OLAJBJFLfATdB\\zBn@UJMDI?YKQq@w@]i@M]WmBYmCC]U{@?A?A@CAEAA@Wa@cFc@cFEa@AOh@q@jC_D`@g@fCcDHDJCDK?OEMEA"
			);

			var coordinates = points.map(function(item) {
				return {
					lat: item[0],
					lng: item[1]
				};
			});

			this.$refs.poiMap.$mapPromise.then(map => {
				var flightPlanCoordinates = coordinates;
				var flightPath = new google.maps.Polyline({
					path: flightPlanCoordinates,
					geodesic: true,
					strokeColor: "#ff0000",
					strokeOpacity: 1.0,
					strokeWeight: 2
				});

				flightPath.setMap(map);
			});
		},
		addDrawingTools: function() {
			var drawingManager = new google.maps.drawing.DrawingManager({
				drawingMode: google.maps.drawing.OverlayType.MARKER,
				drawingControl: true,
				drawingControlOptions: {
					position: google.maps.ControlPosition.TOP_CENTER,
					drawingModes: ["marker", "circle", "polygon", "polyline", "rectangle"]
				},
				markerOptions: {
					icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png"
				},
				circleOptions: {
					fillColor: "#ffff00",
					fillOpacity: 1,
					strokeWeight: 5,
					clickable: false,
					editable: true,
					zIndex: 1
				}
			});

			this.$refs.poiMap.$mapPromise.then(map => {
				drawingManager.setMap(map);
			});
		}
	},
	computed: {}
};
